import System from 'src/helper/system';
import $ from "jquery";

class currentURLParamMaintainer {
    initialState = {};
    paramName = '';

    constructor(initialState, paramName) {
        this.initialState = initialState;
        this.paramName = paramName;
    }

    setAllToURL = (data = {}) => {
        data = JSON.parse(JSON.stringify(data))
        let l = this.getAllFromURL()
        l[this.paramName] = btoa(JSON.stringify(data))
        console.log("main ", l[this.paramName])
        //This says that string is black-encoded
        if (l[this.paramName] === 'e30=') {
            delete l[this.paramName];
        }
        history.replaceState(null, null, "?" + $.param(l));
    }

    getAllFromURL = (l = false) => {
        if (!l) {
            l = System.getParams()
        }
        if (l[this.paramName]) {
            try {
                l[this.paramName] = JSON.parse(atob(l[this.paramName]))
            } catch (e) {
                l[this.paramName] = this.initialState
            }
        } else {
            l[this.paramName] = this.initialState
        }
        return l;
    }

    getSingleFromURL = () => {
        if (this.getAllFromURL()[this.paramName]) {
            return this.getAllFromURL()[this.paramName];
        }
        return this.initialState;
    }
}

export default currentURLParamMaintainer;